import { Button, Group, LoadingOverlay, Stack, Textarea } from "@mantine/core";
import { useForm } from "@mantine/form";
import type { JSX } from "react";

export interface IFormValues {
    referenceAnswer: string;
    llmJudge: string;
}

interface IProps {
    handleSubmit: (values: IFormValues) => void;
    initialValues?: IFormValues;
    fetching: boolean;
}

function ReferenceForm({ handleSubmit, initialValues, fetching }: IProps): JSX.Element {
    const form = useForm<IFormValues>({
        initialValues: initialValues ?? {
            referenceAnswer: "",
            llmJudge: "",
        },
    });

    return (
        <form onSubmit={form.onSubmit(handleSubmit)}>
            <Stack maw={800} mx="auto">
                <LoadingOverlay visible={fetching} />
                <Textarea autosize minRows={3} label="Reference answer" {...form.getInputProps("referenceAnswer")} />
                <Textarea autosize minRows={3} label="LLM Judge rubric" {...form.getInputProps("llmJudge")} />
                <Group justify="flex-end" mt="md">
                    <Button type="submit" disabled={fetching}>
                        Save
                    </Button>
                </Group>
            </Stack>
        </form>
    );
}

export default ReferenceForm;
